export class FindingStatusFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<FindingStatus>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<FindingStatus>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FindingStatusFilters.attributeTypeMap;
    }
    constructor() {
    }
}
